'use strict';

/** @type {import('./gOPD')} */
module.exports = Object.getOwnPropertyDescriptor;



//////////////////
// WEBPACK FOOTER
// ./~/gopd/gOPD.js
// module id = ZdvT
// module chunks = 3